/* eslint-disable react-hooks/rules-of-hooks */
import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";
import { z } from "zod";

export const AddEmployeeSchema = z.object({
  name: z.string().min(3),
  email: z.string().email(),
  role: z.string().min(3),
  company: z.string().min(3),
  // optionals
  phoneNumber: z.string().optional(),
  nationality: z.string().optional(),
  gender: z.string().optional(),
  dateOfBirth: z.date().optional(),
  idNumber: z.string().optional(),
  address: z.string().optional(),
  photo: z.string().optional(),
});

export type AddEmployeeSchemaType = z.infer<typeof AddEmployeeSchema>;
export async function addEmployee(formData: AddEmployeeSchemaType) {
  try {
    const response = await axiosInstance.post(
      `${config.apiUrl}/auth/create-employee`,
      formData
    );
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error:", error.response?.data);
    } else {
      console.error("Unknown error:", error);
    }
    throw error;
  }
}
